export const getImageUrlFromText = (text: string): {imageUrls: string[]; textParts: string[]} => {
    let imageUrls: string[] = [];
    let textParts: string[] = [];
    let sortedQuestionText = text;
    let hasUrl = true;

    do {
        const startImgUrl = sortedQuestionText.split('{{')[1];
        const imageUrl = startImgUrl ? startImgUrl.split('}}')[0] : null;
        textParts = !textParts.length ? [sortedQuestionText.split('{{')[0]] : textParts;

        if (imageUrl) {
            textParts = [...textParts, startImgUrl.split('}}')[1]];
            imageUrls = [...imageUrls, imageUrl];
            sortedQuestionText = sortedQuestionText.replace(`{{${imageUrl}}}`, '');
        } else {
            hasUrl = false;
        }
    } while (hasUrl);

    return { imageUrls, textParts };
};
